import NewBusinessCentralProjectModalContent from "BusinessCentral/NewBusinessCentralProjectModalContent";
import { Modal } from "components";
import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";

const NewBusinessCentralProject = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  
  return <>
    <ButtonPrimary
      label={RESX.GeneralLabels.resxNew}
      onClick={() => { setIsModalOpen(true); }}
    />
    <Modal
      title={RESX.GeneralLabels.resxNew}
      isOpen={isModalOpen}
      handleClose={() => { setIsModalOpen(false); }}
      width="tiny"
    >
      <NewBusinessCentralProjectModalContent
        onSaved={() => {
          setIsModalOpen(false);
          window.location.reload();
        }}
      />
    </Modal>
  </>;
};

export default NewBusinessCentralProject;
